import NavBar from "./NavBar/NavBar"
import Header from "./Header/Header"
import About from "./About/About"
import Gallery from "./Gallery/"
import Footer from "./Footer/"
import useLocoScroll from "./Hooks/useLocomotive"


import './ExploreContainer.css';
import { useEffect } from "react"

interface ContainerProps { }

const ExploreContainer: React.FC<ContainerProps> = () => {
  // useLocoScroll(true)
  useEffect(()=> {
  
  })



  return (
    <div className="container" id="main-container1" data-scroll-container>
       <div className="intro-screen" data-scroll-section>
         <NavBar/>
         <Header/>
         </div>
         <About/>
         <Gallery/>
         <Footer/>
         
    </div>
  );
};

export default ExploreContainer;
